<template>
	<div>
		<quill-editor
			class="editor"
			ref="myTextEditor"
			:value="content"
			:options="editorOption"
			@change="onEditorChange"
			@blur="onEditorBlur($event)"
			@focus="onEditorFocus($event)"
			@ready="onEditorReady($event)"
		/>
	</div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
	props: {
        index: {
            type: Number,
            required: false
        },
		toolbar: {
			type: Array,
			required: false,
			default: [
				['bold', 'italic', 'underline', 'strike'],
				['blockquote', 'code-block'],
				[{ 'header': 1 }, { 'header': 2 }],
				[{ 'list': 'ordered' }, { 'list': 'bullet' }],
				[{ 'script': 'sub' }, { 'script': 'super' }],
				[{ 'indent': '-1' }, { 'indent': '+1' }],
				[{ 'direction': 'rtl' }],
				[{ 'size': ['small', false, 'large', 'huge'] }],
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				[{ 'font': [] }],
				[{ 'color': [] }, { 'background': [] }],
				[{ 'align': [] }],
				['clean'],
				['link', 'image', 'video']
			]
		},
		theContent: {
			type: String,
			required: false,
			default: ''
		}
	},

	components: {
		quillEditor
	},

	data () {
		return {
			editorOption: {
				modules: {
					toolbar: this.toolbar
				},
				placeholder: 'Plaats hier jouw tekst',
			}
		}
	},

	computed: {
		content () {
			return this.theContent
		}
    },

	methods: {
		onEditorChange: _.debounce(function(value, elem = this) {
            let data = value.html

            if(typeof(this.index) == 'number'){
                data = {
                    html: value.html,
                    index: this.index
                }
            }

			elem.$emit('contentChanged', data)
		}, 250),

		onEditorBlur(editor) {
			// console.log('editor blur!', editor)
		},
		onEditorFocus(editor) {
			// console.log('editor focus!', editor)
		},
		onEditorReady(editor) {
			// console.log('editor ready!', editor)
		}
	}

}
</script>